import { apiAxios } from "./apiConfig"; // adjust path if needed

export interface Category {
  id: string;
  name: string;
  status: boolean;
  // add other fields returned by API
}

export interface CategoryListResponse {
  status: boolean;
  message: string;
  data: Category[];
}

export const getCategoryList = async (): Promise<CategoryListResponse> => {
  const response = await apiAxios.get("/category/list");
  return response.data;
};

export interface ResourceItem {
  id: string;
  name: string;
  thumbnail: string;
  categoryId: string;
  createdBy: string;
  updatedBy: string | null;
  createdAt: string;
  updatedAt: string;
  altText: string;
  categoryName: string;

  category: {
    id: string;
    name: string;
  };

  creator: {
    id: string;
    name: string;
    createdAt: string;
    updatedAt: string;
  };

  updater: {
    id: string;
    name: string;
    createdAt: string;
    updatedAt: string;
  };

  fileUrl: string;
}
export interface ResourceListData {
  count: number;
  row: ResourceItem[];
}
export interface ResourceListResponse {
  status: boolean;
  data: ResourceListData;
}

/* ================= API ================= */

export const getResourceList = async (
  page = 1,
  limit = 10,
): Promise<ResourceListResponse> => {
  const response = await apiAxios.get(
    `/resources/list?page=${page}&limit=${limit}`,
  );
  return response.data;
};

export interface ResourceDocument {
  documentFileId: any;
  isActive: boolean;
  documentLink: string;
  documentType: "video" | "file" | "site" | string;
  documentDuration: string;
  documentFileUrl: string;
}

export interface ResourceDetails {
  categoryId: string;
  id: string;
  name: string;
  thumbnail: string;
  altText: string;
  description: string;
  buttonName: string | null;
  fileUrl: string;
  document: ResourceDocument[];
  categoryName: string;
}

export interface ResourceDetailsResponse {
  status: boolean;
  data: ResourceDetails;
}

export const getResourceById = async (
  resourceId: string,
): Promise<ResourceDetailsResponse> => {
  const response = await apiAxios.get(`/resources/${resourceId}`);
  return response.data;
};

/* ================= UPDATE RESOURCE ================= */

export type UpdateDocumentPayload =
  | {
      documentType: "video";
      documentLink: string;
      documentDuration: string;
      isActive: boolean;
    }
  | {
      documentType: "file";
      documentFileId: string;
      isActive: boolean;
    }
  | {
      documentType: "site";
      documentLink: string;
      isActive: boolean;
    };

export interface UpdateResourcePayload {
  name: string;
  description: string;
  altText: string;
  thumbnail: string; // fileId
  categoryId: string;
  document: UpdateDocumentPayload[];
}

export interface UpdateResourceResponse {
  status: boolean;
  data: any[];
}

export const updateResourceById = async (
  resourceID: string,
  payload: UpdateResourcePayload,
): Promise<UpdateResourceResponse> => {
  const response = await apiAxios.put(`/resources/${resourceID}`, payload);
  return response.data;
};

/* ================= CREATE RESOURCE ================= */

export interface CreateResourcePayload {
  name: string;
  description: string;
  altText: string;
  thumbnail: string; // fileId
  categoryId: string;
  document: UpdateDocumentPayload[];
}

export interface CreateResourceResponse {
  status: boolean;
  data: {
    id: string;
    name: string;
    altText: string;
    description: string;
    categoryId: string;
    thumbnail: string;
    createdBy: string;
    createdAt: string;
    updatedAt: string;
    buttonName: string | null;
    updatedBy: string | null;
    document: any[];
  };
}

export const createResource = async (
  payload: CreateResourcePayload,
): Promise<CreateResourceResponse> => {
  const response = await apiAxios.post("/resources/create", payload);
  return response.data;
};

export interface DeleteResourceResponse {
  status: boolean;
  data: string;
}

export const deleteResource = async (
  resourceId: string,
): Promise<DeleteResourceResponse> => {
  const response = await apiAxios.delete(`/resources/${resourceId}`);
  return response.data;
};
